/**
 * Polyfills para compatibilidad cross-browser
 */

// MediaRecorder polyfill para Safari iOS
export async function loadMediaRecorderPolyfill(): Promise<void> {
  if (typeof MediaRecorder === 'undefined' || !MediaRecorder.isTypeSupported) {
    try {
      const AudioRecorder = await import('audio-recorder-polyfill');
      (window as any).MediaRecorder = AudioRecorder.default || AudioRecorder;
    } catch (error) {
      console.warn('MediaRecorder polyfill no disponible:', error);
    }
  }
}

// AudioContext polyfill para navegadores antiguos
export function getAudioContext(): AudioContext | null {
  const AudioContextClass = 
    (window as any).AudioContext || 
    (window as any).webkitAudioContext ||
    null;
  
  if (!AudioContextClass) {
    console.warn('AudioContext no soportado en este navegador');
    return null;
  }

  return new AudioContextClass();
}

// IndexedDB polyfill si es necesario
export function checkIndexedDBSupport(): boolean {
  return 'indexedDB' in window;
}

// Cargar todos los polyfills necesarios
export async function loadPolyfills(): Promise<void> {
  const browserInfo = await import('./browserDetection').then(m => m.detectBrowser());
  
  if (browserInfo.isSafariIOS && !browserInfo.supportsMediaRecorder) {
    await loadMediaRecorderPolyfill();
  }
}


